module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter02"
    }
  }), _vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Every night I woke up to the sound of my neighbors’ lovemaking, which seemed to go on forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Good Lord, it’s too hot for all that screwing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The bedroom would shake, walls vibrated, and the dresser started doing the conga. Kennedy and I slept in the same bed because we were temporarily living in a one bedroom, but just until a two bedroom opened up. ETA on a two bedroom in the Block was about three years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Put it in again, Big Papa!” she screamed. “Put it in again!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh God,” I whispered under my breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What time was Big Papa putting it in tonight?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A glance at the clock revealed 10:10 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Oh, Big Papa was early tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He usually didn’t put it in till after midnight. I slid beneath the covers to save myself from an inevitable discussion of the birds and the bees with Kennedy. We probably should have talked about it by now, but every time I tried to discuss the sensitive topic, my tongue twisted, folded up into the back of my throat, and slid down backward. "), _c('em', [_vm._v("Okay.")]), _vm._v(" I may not have "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("lost my tongue but I certainly felt as though my mouth were filled with concrete when it came to discussing the whole sex thing with the kid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Should we be talking about this?” Kennedy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When I deemed it appropriate that I should stop hiding, I peeked through the covers and saw Kennedy staring at the wall where the sounds were coming from. She looked like she was trying to figure it all out—not that she didn’t already know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yeah,” I mumbled under my breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Okay,” she said, sitting up in the bed. “Go for it, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She sat up and waited, waited for me to deliver some earth-shattering speech on sexuality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well . . .” I started, then stopped and fumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Umm . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Er, um . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Uh . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yeah . . . well . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As I butchered the birds and the bees, the background noise set the tone with moans in A minor, a bed shaking in the chord of C, and a butt spanking in A flat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was looking at Kennedy. Kennedy was looking at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yeah,” Kennedy said, lying back down. “I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Good,” I said, patting her on the back. “If you got any questions just let me know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Okay. Deep breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I slithered from the bed and slipped into a housecoat and slippers, suiting up like a Trojan warrior—no pun intended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I had only lived here for about a week, and this was definitely not the most opportune time for a meet and greet with the neighbors. However, it was as good a time as any, especially considering my twelve-year-old was soaking up their primate noise like the sound editor on a porn flick. I looked over at Kennedy, who looked at me and smirked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Better get some sleep. We got an early day tomorrow,” I commanded, feeling the need to say "), _c('em', [_vm._v("something")]), _vm._v(" parental even if "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("I couldn’t say something smart. The moment felt too bizarre to breed intelligence, so I stepped outside my apartment into the hot air and followed the sounds of moaning, which were right next door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I live next door to a freak.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I knocked on the door several times, tapping my foot impatiently, waiting for the squeaking bed to silence and the loud talk to hush to a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Slowly, the splintered brown door opened, but just enough to reveal one piercing green eye. In the background, a heavy male voice called, “Who’s that, babe?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Neighbor,” she answered him, with that one eye fixated on me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Excuse me,” I said stiffly, “but you’re making too much noise . . . If you could just keep it down. You know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her green eye widened, and there was nothing but silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I have a kid,” I said, nodding my head. “And she’s twelve.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Then she’s probably fucking too,” she said with a straight face, then burst into laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I stared at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m just fooling,” she quickly added. “I’m fooling with you,” she said again, opening the door wide, giving me the first real look at her. She was a white girl with a figure shaped like a box. Her breasts were hefty, but I bet money her backside was flat and wide. She had emerald-colored eyes and bleached blond hair in cornrows. She was "), _c('em', [_vm._v("okay")]), _vm._v(" looking for a white girl. As I examined her further, it appeared that Caucasia and the inner city had collided. She was drinking a Colt 45 and there was a glide in this girl’s stride that didn’t quite fit her own culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“So you’re the new neighbor?” she asked, head cocked back, eyes cast toward the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yeah . . . we’re Christians,” I said slowly, hoping she would get the picture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Cool,” she replied with uncertainty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("“It’s just too loud,” I said, pointing to our adjoining bedroom windows. She nodded, then smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Sorry,” she said. “I’ll tell Gerry to keep it down next time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Then without so much as a good-bye, she quickly shut the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("What a weirdo,")]), _vm._v(" I thought. As I turned to go back inside my apartment, she ripped the door open and blurted out, “Hey!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I halted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What’s your name?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Vanessa,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She stared at me with a blank expression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Vanessa,” I repeated. "), _c('em', [_vm._v("C’mon girl. This isn’t an advanced round of")]), _vm._v(" Jeopardy! “Just Vanessa.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Vanessa,” she mimicked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What’s yours?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Anese,” she said proudly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Nice to meet your slow ass,")]), _vm._v(" I felt like saying. Instead I said, “Good night, Anese.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f8fa7de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter02.vue
// module id = 81
// module chunks = 0